import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Archive",
    body: "JFLY is a living archive of pre-loved clothing. Every piece is sourced by hand — from estate sales, flea markets, and friends' closets — then cleaned, steamed, and photographed before it earns a place here.",
  },
  {
    n: "02",
    title: "Curation",
    body: "No filler. If a piece doesn't have a story, a silhouette, or a reason to exist twice, it doesn't make the cut. What you see is the edit — the best of what we find.",
  },
  {
    n: "03",
    title: "Scarcity",
    body: "Everything here is one of one. There is no size run, no restock, no waitlist. When a piece sells, it leaves the archive forever — that is the point.",
  },
  {
    n: "04",
    title: "Sustainability",
    body: "The most sustainable garment is the one that already exists. Buying pre-loved keeps clothing in circulation and out of landfill. Good clothes deserve a second life.",
  },
];

export const Manifesto = () => {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="border-t-2 border-[#F5F2EB] px-6 py-24 md:px-12 md:py-28 lg:px-20">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-12"
      >
        <p className="mb-4 inline-block rounded-full border-2 border-[#F5F2EB] bg-[#141414] px-4 py-1 text-[10px] font-mono font-medium uppercase tracking-[0.25em]">
          02 — Why JFLY
        </p>
        <h2 data-testid="manifesto-heading" className="font-serif font-black uppercase leading-none tracking-tight text-4xl sm:text-5xl lg:text-6xl">
          Why JFLY exists
        </h2>
      </motion.div>

      <div>
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            data-testid={`manifesto-chapter-${c.n}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: 0.05 * i }}
            className="grid gap-4 border-t-2 border-[#F5F2EB]/10 py-10 md:grid-cols-12 md:gap-8"
          >
            <p className="font-mono text-3xl font-semibold tracking-tighter text-[#FF3B1F] md:col-span-2">{c.n}</p>
            <h3 className="font-serif text-2xl font-black uppercase tracking-tight md:col-span-4">{c.title}</h3>
            <p className="text-sm leading-relaxed text-[#F5F2EB]/60 md:col-span-6">{c.body}</p>
          </motion.div>
        ))}
      </div>

      <motion.div
        data-testid="manifesto-editorial"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7 }}
        className="mt-14 -rotate-1 rounded-2xl border-2 border-[#F5F2EB] bg-[#FF3B1F] p-10 shadow-[8px_8px_0_#F5F2EB] md:p-16"
      >
        <p data-testid="manifesto-quote" className="mx-auto max-w-3xl text-center font-serif text-2xl font-black uppercase leading-tight text-white md:text-4xl">
          “The most sustainable garment is the one that already exists.”
        </p>
      </motion.div>
    </section>
  );
};
